import ActivityOverview from "../../Activities/ActivityOverview/ActivityOverview";

const ActivityOverviewPage = () => {
  return <ActivityOverview />;
};

export default ActivityOverviewPage;
